import { render, staticRenderFns } from "./org-cards.vue?vue&type=template&id=1fca53f0&"
import script from "./org-cards.vue?vue&type=script&lang=js&"
export * from "./org-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports